export default "__VITE_ASSET__BNxGungG__"